document.addEventListener('DOMContentLoaded', () => {
    let spare_parts_sources = document.querySelectorAll('input[name="cms_zero_cash_proposal[spare_parts_source]"]');

    if (spare_parts_sources.length !== 0) {
        function handler(input) {
            let spare_parts_provider_wrapper = document.querySelector('#cms_zero_cash_proposal_spare_parts_provider_id_input');

            if (input.value === 'other') {
                spare_parts_provider_wrapper.classList.remove('hidden');
            } else {
                spare_parts_provider_wrapper.classList.add('hidden');
            }
        }

        let spare_parts_source_selected = null;

        for (var i = 0, len = spare_parts_sources.length; i < len; ++i) {
            if (spare_parts_sources[i].checked) {
                spare_parts_source_selected = spare_parts_sources[i];
                break;
            }
        }

        if (spare_parts_source_selected !== null) {
            handler(spare_parts_source_selected);
        }

        spare_parts_sources.forEach(function (spare_parts_source) {
            spare_parts_source.addEventListener('click', function () {
                handler(this);
            })
        });
    }
});
